<template>
  <div :class="containerClass" class="side-bar-content">
    <v-card id="appsideBar" :tile="true" color="surface lighten-1">
      <keep-alive>
        <component :is="currentSideBar" class="side-bar-component" />
      </keep-alive>
    </v-card>
  </div>
</template>

<script>
import EcsChatSideBar from '@/components/ecs-app-side-bar/ecs-chat-side-bar/EcsChatSideBar';
import EcsDashboardSideBar from '@/components/ecs-app-side-bar/ecs-dashboard-side-bar/EcsDashboardSideBar';
import EcsDashboardSupervisorSideBar from '@/components/ecs-app-side-bar/ecs-dashboard-side-bar/ecs-supervisor-side-bar/EcsDashboardSupervisorSideBar';
import EcsEmailSideBar from '@/components/ecs-app-side-bar/ecs-email-side-bar/EcsEmailSideBar';
import EcsHelpSideBar from '@/components/ecs-app-side-bar/ecs-help-side-bar/EcsHelpSideBar';
import EcsSupervisorSideBar from '@/components/ecs-app-side-bar/ecs-supervisor-side-bar/EcsSupervisorSideBar';
import EcsSettingsSideBar from '@/components/ecs-app-side-bar/ecs-settings-side-bar/EcsSettingsSideBar';
import EcsTelephonySideBar from '@/components/ecs-app-side-bar/ecs-telephony-side-bar/EcsTelephonySideBar';
import EcsSmsSideBar from '@/components/ecs-app-side-bar/ecs-sms-side-bar/EcsSmsSideBar';

export default {
  name: 'EcsAppSideBar',

  components: {
    EcsChatSideBar,
    EcsDashboardSideBar,
    EcsDashboardSupervisorSideBar,
    EcsEmailSideBar,
    EcsSupervisorSideBar,
    EcsHelpSideBar,
    EcsSettingsSideBar,
    EcsTelephonySideBar,
    EcsSmsSideBar
  },

  props: {
    borderRadius: {
      type: Boolean,
      default: false
    },
    selectedMenu: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  computed: {
    currentSideBar() {
      let result;

      const currentSideBar = this.selectedMenu ? this.selectedMenu.name : 'Help';

      switch (currentSideBar) {
        case 'Dashboards':
          result = 'EcsDashboardSideBar';
          break;
        case 'Chats':
          result = 'EcsChatSideBar';
          break;
        case 'Calls':
          result = 'EcsTelephonySideBar';
          break;
        case 'Emails':
          result = 'EcsEmailSideBar';
          break;
        case 'Sms':
          result = 'EcsSmsSideBar';
          break;
        case 'Supervisor':
          result = 'EcsSupervisorSideBar';
          break;
        case 'Settings':
          result = 'EcsSettingsSideBar';
          break;
        case 'Help':
          result = 'EcsHelpSideBar';
          break;
        default:
          result = 'EcsHelpSideBar';
          break;
      }

      return result;
    },

    containerClass() {
      return this.borderRadius ? 'border-radius' : '';
    }
  }
};
</script>

<style scoped>
.side-bar-content {
  border-style: solid;
  border-width: 1px;
  border-color: var(--v-border-color);
  height: calc(100vh - 64px);
  overflow: hidden;
}
.border-radius {
  border-top-left-radius: 10px;
  transition: all 200ms;
}
</style>
